import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { Stack } from 'components/Stack'
import {
  TimelineRoot,
  BannerWrapper,
  Subtitle,
  BannerText,
  HappyDogWrapper,
  TimelineWrapper,
  ArrowWrapper,
  SectionWrapper,
  WeekWrapper,
  BadgeWrapper,
  RedLineWrapper,
  SubHead,
  Result,
  DesktopBorderWave,
  MobileBorderWave,
} from './Timeline.styles'
import Image from 'next/image'
import HappyDog from '../../../../../public/assets/recipes/categories/fluffy-dog.png'
import RedArrow from '../../../../../public/assets/recipes/categories/timeline-arrow.png'
import RedLine from '../../../../../public/assets/recipes/categories/timeline-m.png'
import Badge from '../../../../../public/assets/recipes/categories/some-bones-badge.png'
import Trans from 'next-translate/Trans'
import { Button } from 'components/Button'
import { Box } from 'components/Box'

type TimelineOwnProps = ComponentProps<typeof TimelineRoot>
export type TimelineProps = TimelineOwnProps & {
  banner?: boolean
}

export const Timeline = (_props: TimelineProps) => {
  const { t } = useTranslation()

  const { banner = false } = _props

  const weeksList: number[] = [1, 2, 3, 4]

  return (
    <TimelineRoot id="recipes-1">
      {banner && (
        <>
          <BannerWrapper>
            <BannerText>{t('recipes:overview.timeline.title')}</BannerText>
          </BannerWrapper>
          <DesktopBorderWave
            svgHeight="83px"
            svgWidth="calc(139% + 1.3px)"
            background="primary-500"
            path="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
          />
          <MobileBorderWave
            background="primary-500"
            svgHeight="64px"
            svgWidth="calc(144% + 1.3px)"
            path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
            invert
          />{' '}
        </>
      )}
      <Subtitle>{t('recipes:overview.timeline.subtitle')}</Subtitle>
      <SectionWrapper>
        <BadgeWrapper>
          <Image src={Badge} alt="" />
        </BadgeWrapper>
        <HappyDogWrapper>
          <Image src={HappyDog} alt={t('recipes:overview.timeline.dog')} />
        </HappyDogWrapper>
        <TimelineWrapper>
          <SubHead desktopOnly>{t('recipes:overview.timeline.benefits.title')}</SubHead>
          <SubHead mobileOnly align="start">
            {t('recipes:overview.timeline.benefits.title-m')}
          </SubHead>
          <Stack gap={{ '@initial': '0', '@bp1': '4', '@bp2': '2' }} css={{ position: 'relative' }}>
            <ArrowWrapper>
              <Image src={RedArrow} alt="" />
            </ArrowWrapper>
            <RedLineWrapper>
              <Image src={RedLine} alt="" />
            </RedLineWrapper>
            {weeksList.map((week) => (
              <WeekWrapper key={week} num={week}>
                <SubHead>
                  <Trans
                    components={{ br: <br /> }}
                    i18nKey={`recipes:overview.timeline.benefits.week-${week}.label`}
                  />
                </SubHead>
                <Result desktopOnly>
                  <Trans
                    components={{ br: <br /> }}
                    i18nKey={`recipes:overview.timeline.benefits.week-${week}.result`}
                  />
                </Result>
                <Result mobileOnly>
                  <Trans
                    components={{ br: <br /> }}
                    i18nKey={`recipes:overview.timeline.benefits.week-${week}.result-m`}
                  />
                </Result>
              </WeekWrapper>
            ))}
          </Stack>
          <Box
            css={{
              display: 'none',
              '@bp3': { display: 'block' },
            }}
          >
            <Link href="/meal-plan">
              <Button>{t('recipes:overview.cta-2')}</Button>
            </Link>
          </Box>
        </TimelineWrapper>
      </SectionWrapper>
    </TimelineRoot>
  )
}

Timeline.displayName = 'Timeline'
